<template>
  <div class="stepModal position-relative">
    <div class="modal fade" id="addAdminLockModal" data-keyboard="false" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="twoFAStepModal">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="twoFAStepModalHeader">Add New Access User</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div v-if="loading" class="loader"/>
            <form v-else @submit.prevent="addAdmin">
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label>Username</label>
                    <input type="text" class="form-control" required v-model.trim="username">
                  </div>
                  <div class="form-group">
                    <label>Password</label>
                    <input type="text" class="form-control" required v-model.trim="password">
                  </div>
                  <button class="btn btn-primary" type="submit" >Add</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
name: "addAdminModal",
  data () {
    return {
      username: null,
      password: null,
      loading: false,
      domain: null,
      ip: null
    }
  },
  computed: {
    user() {
      return this.$store.getters.user;
    }
  },
  methods: {
    load () {
      $('#addAdminLockModal').modal('show');
      $('.modal-backdrop').removeClass("modal-backdrop");
    },
    async addAdmin () {
      this.loading = true
      await this.$parent.addAdmin({
        username: this.username,
        password: this.password,
      })
      this.username = null
      this.password = null
      $('#addAdminLockModal').modal('hide');
      this.loading = false
    }
  }
}
</script>

<style scoped>

</style>
